import React, { useContext, useEffect } from "react";
// import PropTypes from 'prop-types'
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SelectComp from "./elements/SelectComp";
import { InfoContext } from "../services/Context/Info/context";
import BannerDB from "../services/db/banner";
import { objToSearch } from "../utils/objToSearch";
import AddBanner from "./elements/AddBanner";
import { DeleteOutline } from "@mui/icons-material";

function Banner() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const {
    data: { bannerData },
    setData,
  } = useContext(InfoContext);

  console.log("bannerData", bannerData);

  const usp = new URLSearchParams(search);
  const limit = usp.get("limit")?.length ? usp.get("limit") : "10";
  const page = usp.get("page")?.length ? usp.get("page") : "0";
  useEffect(() => {
    new BannerDB()
      .allBanners(limit ? parseInt(limit) : 10, page ? parseInt(page) : 0)
      .then((r) => {
        if (r?.length) setData((p) => ({ ...p, bannerData: r }));
      });
  }, [search]);
  const hDeleteBanner = (p) => {
    new BannerDB()
      .deleteBanner(p)
      .then(() => {
        alert("Successfully Deleted Banner");
        setData((pr) => ({
          ...pr,
          bannerData: bannerData.filter((e) => e.id !== p.id),
        }));
      })
      .catch(() => alert("Something Went wrong"));
  };
  const handlePagination = (d) => {
    const fg = {
      limit: limit ?? 10,
      page: page ?? 0,
    };
    fg[d.target.name] = d.target.value;
    const spString = objToSearch(fg);
    navigate({ pathname, search: spString });
  };
  const handlePrev = () => {
    const d = { target: { name: "page", value: parseInt(page) - 1 } };
    handlePagination(d);
  };
  const handleNext = () => {
    const d = { target: { name: "page", value: parseInt(page) + 1 } };
    handlePagination(d);
  };
  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(100vh - 64px)",
        display: "flex",
        padding: 2,
        flexDirection: "column",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Typography>Banner</Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <SelectComp
            label="Show Entries"
            data={[10, 20, 30, 40, 50]}
            handleChange={handlePagination}
            value={parseInt(limit || 10)}
            name="limit"
            size="small"
            variant="outlined"
          />
          <Box>
            <AddBanner bannerData={bannerData} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: "100%", overflowY: "scroll", flex: 1 }}>
        {bannerData.map((el) => (
          <Box
            key={el.id}
            sx={{
              width: "80vw",
              marginY: 2,
              marginX: "auto",
              padding: 2,
              backgroundColor: "#FAF0E6",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span>{el.location}</span>
              <img width="200px" height="200px" src={el.photo} />
            </div>
            <Box
              sx={{ width: "25%", display: "flex", justifyContent: "center" }}
            >
              <IconButton onClick={() => hDeleteBanner(el)}>
                <DeleteOutline />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          disabled={parseInt(page) === 0}
          onClick={handlePrev}
        >
          Previous
        </Button>
        <Typography sx={{ paddingX: 2 }}>{parseInt(page) + 1}</Typography>
        <Button
          variant="contained"
          color="primary"
          disabled={bannerData.length < parseInt(limit)}
          onClick={handleNext}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
}

// Banner.propTypes = {}

export default Banner;
